// @flow

import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import './page-header.scss';

type Props = {
  title: string,
  subTitle: string,
  tuneCode: string,
  membershipNo: string,
  backLinkTo: string,
  backLinkText: string,
  iconClassName: string,
  alignLeft: boolean,
  children: Element,
  backLinkOnClick: Function,
  onShareButtonClick: Function,
};

const PageHeader = (props: Props) => {
  const {
    title,
    subTitle,
    tuneCode,
    alignLeft,
    backLinkTo,
    backLinkText,
    children,
    membershipNo,
    iconClassName,
    backLinkOnClick,
    onShareButtonClick,
  } = props;
  let shouldAlignCenter = true;

  if (alignLeft) {
    shouldAlignCenter = false;
  }

  return (
    <header className={classnames(
      'page_header d-flex flex-column',
      { 'align-items-center': shouldAlignCenter },
      { 'with-tabs': children && children.length },
    )}
    >
      <NavLink to={backLinkTo} onClick={backLinkOnClick} className="page_header__link mr-auto">
        <span className="prs-icon prs-icon-chevron-left" />
        {backLinkText}
      </NavLink>
      {iconClassName && <span className={classnames(['prs-icon page-header--icon', iconClassName])} />}
      <h1>{title}</h1>
      {subTitle && <p>{subTitle}</p>}
      {tuneCode && (
        <div className="page_header--more-info d-flex flex-row justify-content-between align-items-center">
          <p className="smaller m-0">
            Tunecode:
            <strong>{tuneCode}</strong>
          </p>
          {onShareButtonClick && <button type="button" className="prs-icon prs-icon-share" onClick={onShareButtonClick} />}
        </div>
      )}
      {membershipNo && (
        <p className="smaller">
          Membership no.
          <strong>{membershipNo}</strong>
        </p>
      )}
      <div className="page_header--tabs d-flex flex-row justify-content-between">
        {children}
      </div>
    </header>
  );
};

type TabProps = {
  onClick: Function,
  active: boolean,
  children: Element,
};

export const PageHeaderTab = (props: TabProps) => {
  const { onClick, children, active } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      className={classnames(
        'page_header--tab',
        { active },
      )}
    >
      {children}
    </button>
  );
};

export default PageHeader;
